import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgRentRight = (props) => (
  <SvgIcon {...props} title="RentRight">
    <svg
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#RentRight_svg__a)" fill="#017163">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.355 1.243c-.435.066-1.151.321-1.566.559C18.166 2.158.411 17.22.229 17.548c-.712 1.274.717 2.764 2.002 2.089.172-.09 3.418-2.807 9.128-7.64 4.873-4.126 8.959-7.553 9.08-7.617.328-.173.92-.17 1.252.009.13.069 3.572 2.95 7.652 6.404 4.693 3.973 7.486 6.306 7.605 6.354 1.389.555 2.679-.97 1.882-2.227-.149-.235-14.763-12.64-15.328-13.012-.846-.555-2.11-.822-3.147-.665Zm10.825.574c-1.382.378-1.54 2.258-.24 2.86.215.098.272.1 2.67.114l2.448.013v4.849l.134.28c.546 1.154 2.223 1.142 2.744-.02l.125-.277-.013-3.414-.013-3.413-.138-.25c-.169-.303-.383-.498-.727-.66l-.26-.121-3.258-.01c-2.483-.007-3.309.005-3.472.05Zm-24 17.998c-.45.128-.775.389-.995.8l-.103.194v8.133c0 7.604.005 8.152.082 8.43.46 1.663 1.636 2.85 3.27 3.296l.398.11h3.562c3.552 0 3.563 0 3.782-.102 1.195-.552 1.191-2.215-.006-2.776l-.26-.122-3.375-.024-3.375-.023-.22-.109a1.713 1.713 0 0 1-.737-.759l-.121-.257-.024-7.899-.023-7.898-.138-.25c-.33-.595-1.085-.922-1.717-.744Zm26.341-.01c-11.388.878-16.61 14.718-8.645 22.911 6.83 7.024 18.65 4.644 22.264-4.483 3.656-9.231-3.705-19.191-13.619-18.427Zm2.002 3.046c7.349.715 11.71 8.589 8.383 15.137-3.897 7.673-14.799 7.673-18.696 0-3.7-7.284 2.19-15.928 10.313-15.137Z"
        />
        <path d="M32.054 29.785v3.5c-.582-.043-1.553-.031-1.564.701-.011.733.88.84 1.42.845-.003.4-.008 1.327 0 1.836.009.51-.599.698-.904.728-.26.055-.78.328-.78.985 0 .656.48.889.719.923h6.461c.308 0 .923-.185.923-.923 0-.739-.615-.965-.923-.985h-3.63v-2.564h2.317c.253-.041.76-.259.76-.8 0-.542-.507-.723-.76-.746h-2.318V29.97c-.02-.349.267-1.046 1.21-1.046.944 0 1.355.575 1.396.862.013.5.237 1.501 1.025 1.517.788.017.793-1.004.698-1.517-.062-.84-.772-2.544-3.118-2.626-2.347-.082-2.933 1.717-2.932 2.626Z" />
      </g>
      <defs>
        <clipPath id="RentRight_svg__a">
          <path fill="#fff" transform="translate(.04)" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgRentRight;
